// Copyright ©️ 2026 eVolve MEP, LLC

import { useEvolvePaginatedGet, type Shipment } from '@evolvemep/api-ts';

import { ActivityFeed } from 'components/Mantine/ActivityFeed';

type Props = {
  shipment: Shipment;
};

export const ShipmentActivityFeed = ({ shipment }: Props) => {
  const paginatedGet = useEvolvePaginatedGet(`shop/shipment/${shipment.shipmentId}/statusHistory`);

  return (
    <ActivityFeed
      paginatedGet={paginatedGet}
      getActivityFeedItem={(e) => ({
        ...e,
        // FIXME: `createdBy` should be renamed to `createdByUser` on the backend to be consistent
        createdByUser: e.createdBy,
        label: e.shipmentStatusName ?? e.shipmentStateName,
      })}
      currentStatus={shipment.shipmentStatusId ?? shipment.shipmentStateId}
    />
  );
};
